import type { CrudOperators } from "@refinedev/core";

export const mapOperator = (operator: CrudOperators): string => {
  switch (operator) {
    case "eq":
      return "$eq:";
    case "ne":
      return "$not:";
    case "lt":
      return "$lt:";
    case "gt":
      return "$gt:";
    case "lte":
      return "$lte:";
    case "gte":
      return "$gte:";
    case "in":
      return "$in:";
    case "contains":
      return "$ilike:";
    case "between":
      return "$btw:";
    default:
      return "";
  }
};
